import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6 12.7v-4c0-.8-.6-1.4-1.3-1.4H3.3C2.6 7.3 2 8 2 8.7v4c0 .7.6 1.3 1.3 1.3h1.4c.7 0 1.3-.6 1.3-1.3Zm0 0V6c0-.7.6-1.3 1.3-1.3h1.4c.7 0 1.3.6 1.3 1.3v6.7m-4 0c0 .7.6 1.3 1.3 1.3h1.4c.7 0 1.3-.6 1.3-1.3m0 0V3.3c0-.7.6-1.3 1.3-1.3h1.4c.7 0 1.3.6 1.3 1.3v9.4c0 .7-.6 1.3-1.3 1.3h-1.4c-.7 0-1.3-.6-1.3-1.3Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }